export default class NumberRangeOptimizerDataSourceEnum {
  static NNGT = 'NNGT';
  static MSISDN = 'MSISDN';
}
